module.exports = __webpack_public_path__ + "static/media/memberHeader.07c2b3bf.png";